import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface DropDownProps {
	title?: string
	list?: Object[]
	title_component?: React.ReactElement
	template?: (element, index) => React.ReactElement
	placeholder?: string
}

export const DropDown = ({
	title = 'list',
	list = [],
	title_component,
	template = (element, index) => {
		return (
			<div className="text-sm rounded-lg border border-slate-300 flex" key={index}>
				<div className="text-left pl-5"> {element.name} </div>
			</div>
		);
	},
	placeholder = "no items"
}: DropDownProps) => {
	const { t } = useTranslation();

	return (
		<div className="dropdown w-full justify-center flex text-sm text-slate-500">
			<div className="hover:bg-[#e9e9e9] py-0.5 w-full justify-center rounded text-center inline-flex items-center border border-slate-300">
				{title}
				{title_component}
			</div>

			<div className="dropdown-content mt-8 absolute z-50 bg-white/50 backdrop-blur-sm divide-y divide-gray-100 rounded-lg shadow" style={{ "width": '19.4rem' }}>
				<div className="py-2 px-1 text-sm text-gray-700" >
					{(list.length > 0) ?
						list.map((element, index) => (
							template(element, index)
						)) :
						<div className="-pt-1 text-slate-500 text-sm"> {placeholder} </div>
					}
				</div>
			</div>
		</div >
	);
}
